import { Component, Input, OnInit } from '@angular/core';
import { SessionService } from '../../../../session.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { CommunicationService } from '../../services/communication.service';
import { CustomNotificationsService } from '../../services/custom-notifications.service';

@Component({
    selector: 'app-file-upload-dialog',
    templateUrl: './file-upload-dialog.component.html',
    styleUrl: './file-upload-dialog.component.scss',
    standalone: false
})
export class FileUploadDialogComponent implements OnInit {
  @Input() dialogDetails: string;
  dialogValues: any;
  userAction: any;
  returnValue: any = {
    isSuccess: false,
    filesObject: {},
  };
  userInputValue: any = null;
  userRemovedValue: any = [];
  fileChangeLogs: any = [];
  userDetails: any;
  constructor(
    public commuServ: CommunicationService,
    private sessionServ: SessionService,
    public activeModal: NgbActiveModal,
    private notifyServ: CustomNotificationsService,
    public sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    let userDetails =
      this.sessionServ.getSessionDetails().user_details.userData;
    this.userDetails = userDetails != null ? userDetails : null;
    this.dialogValues = this.dialogDetails;
    this.userAction = this.dialogValues.object.userAction;
    this.userInputValue = this.dialogValues.object.documents;
    if (userDetails != null) {
      this.userInputValue.forEach((fileElement) => {
        // if (fileElement.isUploaded == true) {
        let changedValues = {
          changedByUsername:
            this.userDetails.username != null
              ? this.userDetails.username.toString()
              : null,
          changedByUserId:
            this.userDetails._id != null
              ? this.userDetails._id.toString()
              : null,
          changedField:
            this.userDetails._id != null
              ? fileElement.fullName.toString()
              : null,
          changedTime: new Date(Date.now()).getTime().toString(),
          oldValue:
            fileElement.description != null
              ? fileElement.description.toString()
              : null,
          newValue: null,
        };
        this.fileChangeLogs.push(changedValues);
        // }
      });
    }
  }

  public decline() {
    this.activeModal.close(this.returnValue);
  }

  public accept() {
    this.returnValue.isSuccess = true;

    this.returnValue.filesObject = {
      uploadDocs: this.userInputValue,
      removeDocs: this.userRemovedValue,
      fileChangeLogs: this.fileChangeLogs,
    };
    this.activeModal.close(this.returnValue);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

  openFilePreview(file) {
    var w = window.open('about:blank');
    setTimeout(function () {
      //FireFox seems to require a setTimeout for this to work.
      w.document.body.appendChild(w.document.createElement('iframe')).src =
        file;
      w.document.getElementsByTagName('iframe')[0].style.width = '100%';
      w.document.getElementsByTagName('iframe')[0].style.height = '100%';
      w.document.getElementsByTagName('iframe')[0].style.border = 'none';
    }, 0);
  }

  setDocuments(files) {
    Array.from(files).forEach((element: any) => {
      let file: any = element;
      file.fileName = new Date(Date.now()).getTime();
      this.commuServ.getBase64(file).then((data) => {
        let fileObject = {
          file: data.toString(),
          fullName: element.name,
          description: null,
          isUploaded: false,
        };
        if (this.commuServ.acceptedFilesExtension(fileObject.file) != null) {
          let changedValues = {
            changedByUsername:
              this.userDetails.username != null
                ? this.userDetails.username.toString()
                : null,
            changedByUserId:
              this.userDetails._id != null
                ? this.userDetails._id.toString()
                : null,
            changedField: 'File',
            changedTime: new Date(Date.now()).getTime(),
            oldValue: null,
            newValue:
              'Name : ' +
              fileObject.fullName +
              ', Description : ' +
              fileObject.description,
          };
          this.fileChangeLogs.push(changedValues);
          this.userInputValue.push(fileObject);
        } else {
          this.notifyServ.warning('Invalid File Format');
        }
      });
    });
  }

  downloadFile(fileObject) {
    if (fileObject.isUploaded == true) {
      let downloadUrl: any = fileObject.downloadURL;
      var downloadFrame = document.createElement('iframe');
      downloadFrame.setAttribute('src', downloadUrl);
      downloadFrame.setAttribute('class', 'screenReaderText');
      document.body.appendChild(downloadFrame);
    } else {
      var a = document.createElement('a'); //Create <a>
      a.href = fileObject.file; //Image Base64 Goes here
      a.download = fileObject.fullName; //File name Here
      a.click(); //Downloaded file
    }
  }

  removeFile(fileObject) {
    let index = this.userInputValue.indexOf(fileObject);
    this.userInputValue.splice(index, 1);
    if (fileObject.isUploaded == true) {
      this.userRemovedValue.push(fileObject.filePath);
      let changedValues = {
        changedByUsername: this.userDetails.username,
        changedByUserId: this.userDetails._id,
        changedField: 'File',
        changedTime: new Date(Date.now()).getTime(),
        oldValue:
          'Name : ' +
          fileObject.fullName +
          ', Description : ' +
          fileObject.description,
        newValue: null,
      };
      this.fileChangeLogs.push(changedValues);
    }
  }

  fileDescription(fileObject, value) {
    this.userInputValue.forEach((fileElement: any) => {
      if (fileElement.file == fileObject.file) {
        fileElement.description = value;
        var fileChangeLogIndex = this.fileChangeLogs.findIndex(
          (p) => p.changedField == fileObject.fullName
        );
        if (fileChangeLogIndex != -1) {
          this.fileChangeLogs[fileChangeLogIndex].newValue = value;
        }
      }
    });
  }

  onSubmit() {
    if (this.userInputValue != null) {
      this.notifyServ.info('Files Are Ready To Upload');
      this.accept();
    } else {
      this.notifyServ.info('Invalid Input');
    }
  }
}
